module.exports = __webpack_public_path__ + "media/button_click.7f98f10f.mp3";